var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['header-menutoggle', { 'is-visible': _vm.state }],on:{"click":function($event){return _vm.toggle()}}},[_vm._m(0),_c('span',{staticClass:"menutoggle-text"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"menutoggle-burger"},[_c('span',{staticClass:"burger-patty"}),_c('span',{staticClass:"burger-patty"}),_c('span',{staticClass:"burger-patty"})])
}]

export { render, staticRenderFns }